import { Grid, Space } from "../../Layout";
import { Texts, Title, Media, Breadcrumb } from "../../Object";
import { Slide } from "../../Animation";
import { useDocumentLoadCompleted } from "../../Hooks";
import { AnimatePresence } from "framer-motion";
import { Scroll } from "../../Animation";

const Head = (props) => {
  
  const type = props.type;
  const isLoaded = useDocumentLoadCompleted();

  let mediaCheck = false;
  if(type === 'noimage') {
    mediaCheck = false;
  } else {
    mediaCheck = true;
  }

  return (
    <>
      <div className="p-page__wrap--head">
        <div className="l-row p-page__wrap--texts">
          <Space size={['164px', '120px']}></Space>
            <Texts class="c-text--main c-text--en c-text--big" slug={`page/en-${props.slug}`}></Texts>
            <Space size={['64px 0 0', '48px 0 0']}>
              <Texts class="c-text--bold" slug={`page/jp-${props.slug}`}></Texts>
            </Space>
            { props.children }
          {/* <Space size={['164px', '120px']}></Space> */}
        </div>
        {mediaCheck && 
          <>
            <AnimatePresence mode="wait">
              {isLoaded &&
                <Scroll>
                  <Media class="p-page__img--head" src={`page-head/${props.slug}`} alt="Hero media"></Media>
                </Scroll>
              }
            </AnimatePresence>
            {/* <Space size={['96px', '72px']}></Space> */}
          </>
        }
        <Breadcrumb></Breadcrumb>
      </div>
    </>
  );
};

export default Head;
